import * as React from "react";
import { Search } from "lucide-react";

import { Input, type InputProps } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface SearchInputProps extends InputProps {
  containerClassName?: string;
  iconClassName?: string;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, iconClassName, type = "search", ...props }, ref) => {
    return (
      <div className={cn("relative", containerClassName)}>
        <Search
          className={cn(
            "pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground",
            iconClassName
          )}
          aria-hidden
        />
        <Input ref={ref} type={type} className={cn("pl-10", className)} {...props} />
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";
